/* OhPunch Theme JS — minimal, progressive enhancement */

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initAccordions();
  initProductThumbs();
});

/* Sticky header — add border on scroll */
function initStickyHeader() {
  const header = document.getElementById('header');
  if (!header) return;
  const observer = new IntersectionObserver(
    ([entry]) => header.classList.toggle('is-scrolled', !entry.isIntersecting),
    { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
  );
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:1px;position:absolute;top:0;left:0;right:0;pointer-events:none;';
  document.body.prepend(sentinel);
  observer.observe(sentinel);
}

/* Accordion toggle */
function initAccordions() {
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const content = item.querySelector('.accordion__content');
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = '0';
        item.classList.remove('is-open');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        item.classList.add('is-open');
      }
    });
  });
}

/* Product page thumbnail switcher */
function initProductThumbs() {
  const mainImage = document.getElementById('product-main-image');
  if (!mainImage) return;

  document.querySelectorAll('[data-thumb-index]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('[data-thumb-index]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      mainImage.src = thumb.src.replace(/width=\d+/, 'width=1200');
    });
  });
}
